import { render } from "./ProposalArgumentInfo.vue?vue&type=template&id=96b7d888&scoped=true"
import script from "./ProposalArgumentInfo.vue?vue&type=script&lang=js"
export * from "./ProposalArgumentInfo.vue?vue&type=script&lang=js"

import "./ProposalArgumentInfo.vue?vue&type=style&index=0&id=96b7d888&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96b7d888"]])

export default __exports__